import { IAuth } from "src/modules/common/general/types/common";

export const getTypeAuthorization = () => {
	return localStorage.getItem("typeAuthorization") as IAuth.AuthTypes;
};
